// Source: app/scripts/directives/combo.js
/*
 * Directive for generic combo (select)
 *
 */

Auction.directive('combo', [
  'crudService',
  '$injector',
  '$filter',
  function(crudService, $injector, $filter) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        fProperties: '@',
        fEntity: '=',
        // The label for translating entity name
        comboLabel: '@',
        comboName: '@',
        // The url of the rest service and the form name
        comboType: '@',
        comboService: '@',
        comboServiceMethod: '@',
        comboServiceParams: '=',
        comboModel: '=',
        comboProperty: '@',
        comboGroupName: '@',
        comboGroupProperty: '@',
        comboRequired: '=',
        renderItem: '=',
        renderSelected: '=',
        onLoad: '=',
        autoSet: '=',
        onChange: '=',
        primitive: '=',
        multiple: '=',
        afterInit: '=',
        allowClear: '=',
        comboTranslate: '=',
        comboDisabled: '=',
        active: '='
      },
      compile: function(tElem, attrs) {

        if(attrs.comboRequired == "true") {
          tElem[0].children[0].children[1].setAttribute("required", true);
        }
        var containerDiv = tElem[0].children[0];
        $(containerDiv).addClass(attrs['class'] || "form-group");

        return function(scope, elem, attrs) {
          scope.form = elem.parent().controller('form');
          scope.fName = attrs.comboName;
          scope.validationParams = attrs;


          scope.comboElem = $(elem.children()[0].children[0]);

          var requiredEl = elem[0].children[0] && elem[0].children[0].children[1];
          scope.$watch('comboRequired', function(required) {
            if (!requiredEl) {
              return;
            }
            if (required) {
              requiredEl.setAttribute('required', 'required');
            } else {
              requiredEl.removeAttribute('required');
            }
          });

        };
      },
      controller: function($scope, $element, crudService, $injector) {
        var service, method;

        var jsonPath = $filter('jsonPath');

        $scope.$watch('fEntity', function(n, o) {
          if(n === o || !n) return;
          $scope.propertiesField = $scope.fProperties || $scope.comboName;
          $scope.fieldProperties = n.fieldProperties;

        });

        $scope.propertiesField = $scope.fProperties || $scope.comboName;
        $scope.fieldProperties = $scope.fEntity.fieldProperties;

        // set the default combo property
        if($scope.comboProperty == null) {
          $scope.comboProperty = 'name';
        }
        var property = $scope.comboProperty;
        var groupProp = $scope.comboGroupName;
        var groupNameProp = $scope.comboGroupProperty;

        var multiple = $scope.multiple || false;

        if($scope.comboLabel) {
          $scope.showLabel = true;
        }

        if($scope.comboType) {
          // Get reference to the service
          service = crudService($scope.comboType);
          if($scope.active){
            method = 'getActive';
          }else{
            method = 'query';
          }

        } else if($scope.comboService) {
          service = $injector.get($scope.comboService);
          method = $scope.comboServiceMethod;
        }

        // Function for highlighting the meching when
        // searching
        $scope.markMatch = function(text, query, escapeMarkup) {
          var markMatch = window.Select2.util.markMatch;
          var markup = [];
          if(query.term) {
            markMatch(text, query.term, markup, escapeMarkup);
            return markup.join("");
          } else {
            return text;
          }
        };



        // Function that returns the item display
        $scope.formatItem = function(item, container, query, escapeMarkup) {
          var val;
          if(item.__isGroup && item.group) {
            val = item.group[groupNameProp]
          } else {
            val = jsonPath(item, property) || item;
          }
          if($scope.comboTranslate) {
            val = $filter('translate')(val);
          }
          var markedText = $scope.markMatch(val, query, escapeMarkup);
          if(typeof $scope.renderItem === 'function') {
            return $scope.renderItem(val, markedText, item);
          } else {
            return markedText;
          }
        };


        $scope.formatResultReadOnly = function () {
          if (multiple && angular.isArray($scope.comboModel)) {
            return $scope.comboModel.map(function(item) {
              return $scope.formatResult(item);
            }).filter(function(text) {
              return text && text.length > 0;
            }).join(', ');
          }
          return $scope.formatResult($scope.comboModel);
        };
        // function for displaying the selected item
        $scope.formatResult = function(item) {
          if(!item) return "";

          var markedText = jsonPath(item, property) || item;
          if($scope.comboTranslate) {
            markedText = $filter('translate')(markedText);
          }

          if(typeof $scope.renderSelected === 'function') {
            var baseText = jsonPath(item, property) || item;
            return $scope.renderSelected(baseText, baseText, item);
          }

          if(groupProp && item[groupProp] && item[groupProp].__isGroup) {
            var x = item[groupProp];
            if($scope.comboTranslate) {
              val = $filter('translate')(jsonPath(item, property)) + ' - <b>' + $filter('translate')(x[groupNameProp]) + '</b>';
            } else {
              markedText = jsonPath(item, property) + ' - <b>' + x[groupNameProp] + '</b>';
            }
          }
          return markedText;
        };

        if($scope.comboFormatResult && typeof $scope.comboFormatResult === 'function') {
          $scope.foramtResult = $scope.comboFormatResult;
        }

        // Function that searches the term throught the items
        $scope.matcher = function(term, text, item) {
          if(item.__isGroup && item.group) {
            return item.group[groupNameProp].toUpperCase().indexOf(
                term.toUpperCase()) >= 0 || item.group[groupNameProp].toUpperCase().indexOf(
                term.toUpperCase()) >= 0;
          } else {
            var val = jsonPath(item, property) || item;
            return val.toUpperCase().indexOf(term.toUpperCase()) >= 0;
          }
        };



        // The config object for the select2
        $scope.options = {
          data: {
            results: [],
            text: property
          },
          allowClear: $scope.allowClear || true,
          triggerChange: true,
          multiple: multiple,
          formatSelection: $scope.formatResult,
          formatResult: $scope.formatItem,
          matcher: $scope.matcher,
          /* паѓачкото мени по ширина на опциите — избегнува скратување (MOVEMENT_CERTIFICATE и сл.) */
          dropdownAutoWidth: true
        };

        if($scope.primitive) {
          $scope.options.id = function(item) {
            return jsonPath(item, property) || item;
          };
        }

        // Function for retrieving the combo items
        $scope.reload = function() {
          var populate = function(data) {
            var res = {};
            if(groupProp) {
              var arrayRes = [];
              angular.forEach(data, function(val) {
                var id;
                var g = val[groupProp];
                if(!g) {
                  id = '--';
                } else {
                  id = g[groupNameProp];
                }
                res[id] = res[id] || {
                  name: id,
                  group: g,
                  children: [],
                  __isGroup: true
                };
                res[id].children.push(val);
              });

              angular.forEach(res, function(v, k) {
                arrayRes.push(v);
              });
              $scope.options.data.results = arrayRes;
            } else {
              $scope.options.data.results = data;
            }
            if($scope.options.data.results && $scope.options.data.results.length == 1 && $scope.autoSet) {

              $scope.comboModel = $scope.options.data.results[0];
            }
            if($scope.onLoad && typeof $scope.onLoad === 'function') {
              $scope.onLoad($scope, $scope.options.data.results);
            }
          };
          if ($scope.data) {
            populate($scope.data)
          } else {
            var params;
            if ($scope.comboServiceParams) {
              params = [$scope.comboServiceParams, populate];
            } else {
              params = [populate];
            }
            if (service) {
              service[method].apply(service, params);
            } else {
              var csrv = crudService($scope.comboType);
              if($scope.active){
                method = 'getActive';
              }else{
                method = 'query';
              }

              csrv[method].apply(service, params);
            }
          }
        };
        if(typeof $scope.afterInit === 'function') {
          $scope.afterInit($scope);
        } else {
          // fetch the combo items
          $scope.reload();
        }
        $scope.$watch('data', function (newVal, oldVal) {
          if (!newVal && oldVal === newVal) return;
          $scope.reload();
        });
      },
      templateUrl: 'directives/combo.html'
    };
  }
]);

Auction.directive('cmbChange', function() {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      element.bind('change', function(e) {
        var fn = scope.$eval(attrs.cmbChange);
        if(typeof fn === 'function') {
          fn(e.added, scope);
        }
      });
    }
  };
});
